import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AccountsDetails from './pages/AccountsDetails';
import ClientManagement from './pages/ClientManagement';
import Logs from './pages/Logs';
import Profile from './pages/Profile';
import { AppProvider, useApp } from './context/AppContext';
import { supabase } from './lib/supabase';
import { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const ProtectedRoute = ({ children }) => {
  const { user } = useApp();
  if (!user) return <Navigate to="/login" />;
  return children;
};

// Move the data fetching logic to a new component
const AppContent = () => {
  const { user, setAccounts, setLogs } = useApp();

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        // Fetch accounts
        const { data: accountsData, error: accountsError } = await supabase
          .from('accounts')
          .select('*');
        
        if (accountsError) throw accountsError;
        setAccounts(accountsData);

        // Fetch logs
        const { data: logsData, error: logsError } = await supabase
          .from('logs')
          .select('*')
          .order('created_at', { ascending: false });
        
        if (logsError) throw logsError;
        setLogs(logsData);

      } catch (error) {
        console.error('Error fetching initial data:', error);
      }
    };

    if (user) {
      fetchInitialData();
    }
  }, [user, setAccounts, setLogs]);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="accounts" element={<AccountsDetails />} />
          <Route path="clients" element={<ClientManagement />} />
          <Route path="logs" element={<Logs />} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Routes>
    </Router>
  );
};

function App() {
  return (
    <AppProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AppContent />
      </LocalizationProvider>
    </AppProvider>
  );
}

export default App;